import { API, apiConfig, ROUTES } from "../../utils/api.url";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
import router from "@/router";
import { toastDispatch } from "@/assets/composables/toast-dispatch";

export default {
	namespaced: true,
	state: {
		estimates: [],
		estimate: [],
		customer_estimate: [],
		url: null,
		customer_history: [],
		total: null,
	},
	mutations: {
		SET_ESTIMATES(state, data) {
			state.estimates = data;
		},
		SET_ESTIMATE(state, data) {
			state.estimate = data;
		},
		SET_CUSTOMER_ESTIMATE(state, data) {
			state.customer_estimate = data;
		},
		SET_EXPORTURL(state, data) {
			state.url = data;
		},
		SET_CUSTOMER_HISTORY(state, data) {
			state.customer_history = data;
		},
		REMOVE_ESTIMATES(state, id) {
			let estimateIndex = state.estimates.data.findIndex(
				(estimate) => estimate.id === id
			);
			state.estimates.data.splice(estimateIndex, 1);
		},
		SET_TOTALPAGES(state, data) {
			state.total = data;
		},
	},
	actions: {
		async getEstimates({ commit }, params) {
			const headers = apiConfig().headers;
			let result = await API.get(ROUTES().estimates, { params, headers })
				.then((res) => {
					commit("SET_ESTIMATES", res.data);
					commit("SET_TOTALPAGES", res.data.meta.total);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async addEstimates({}, payload) {
			let result = await API.post(ROUTES().estimates, payload, apiConfig())
				.then((res) => {
					toastDispatch(res, "success");
					router.push({
						name: "view-estimate",
						params: { id: res.data.data.id },
					});
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});

			return result;
		},
		async getEstimate({ commit }, id) {
			let result = await API.get(`${ROUTES().estimates}/${id}`, apiConfig())
				.then((res) => {
					commit("SET_ESTIMATE", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
		async getCustomerEstimate({ commit }, code) {
			let result = await API.get(ROUTES(code).customerestimate, apiConfig())
				.then((res) => {
					commit("SET_CUSTOMER_ESTIMATE", res.data.data);
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},
		async exportEstimate({ commit }) {
			let result = await API.post(
				`${ROUTES().estimates}/export`,
				{ format: "excel" },
				apiConfig()
			)
				.then((res) => {
					commit("SET_EXPORTURL", res.data.data.url);
					toast.success("Estimates exported successfully");
				})
				.catch((err) => {
					console.log(err);
				});

			return result;
		},

		async editEstimates({}, { id, payload }) {
			let result = await API.put(
				`${ROUTES().estimates}/${id}`,
				payload,
				apiConfig()
			)
				.then((res) => {
					toastDispatch(res, "success");
					router.push({
						name: "view-estimate",
						params: { id: res.data.data.id },
					});
				})
				.catch((err) => {
					toastDispatch(err, "error");
				});

			return result;
		},
		async duplicateEstimate({}, id) {
			let result = API.put(
				`${ROUTES().estimates}/${id}/duplicate`,
				{},
				apiConfig()
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},

		async markAs({}, { id, payload }) {
			let result = API.put(
				`${ROUTES().estimates}/${id}/mark-as`,
				payload,
				apiConfig()
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async deleteEstimate({ commit }, id) {
			let result = API.delete(`${ROUTES().estimates}/${id}`, apiConfig())
				.then((res) => {
					commit("REMOVE_ESTIMATES", id);
					toast.success(`${res.data.message}`);
					return true;
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
		},
		async sendEstimate({}, id) {
			let result = API.post(`${ROUTES().estimates}/${id}/send`, {}, apiConfig())
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
		async convertToInvoice({}, id) {
			let result = API.post(
				`${ROUTES().estimates}/${id}/convert-to-invoice`,
				{},
				apiConfig()
			)
				.then((res) => {
					toast.success(`${res.data.message}`);
				})
				.catch((err) => {
					if (err.response.data.error) {
						toast.error(`${err.response.data.error}`);
					} else {
						toast.error(`${err.response.data.message}`);
					}
				});
			return result;
		},
	},
	getters: {
		estimates(state) {
			return state.estimates;
		},
		estimate(state) {
			return state.estimate;
		},
		customer_estimate(state) {
			return state.customer_estimate;
		},
		url(state) {
			return state.url;
		},
		customer_history(state) {
			return state.customer_history;
		},
		total(state) {
			return state.total;
		},
	},
};
